export const SET_FETCHABLE_FEEDS = 'SET_FETCHABLE_FEEDS'
export const DELETE_FETCHABLE_FEED = 'DELETE_FETCHABLE_FEED'
export const SET_LANDING_CLASSIFIEDS_COUNT = 'SET_LANDING_CLASSIFIEDS_COUNT'
export const SET_LANDING_UNREAD_MESSAGES_COUNT =
  'SET_LANDING_UNREAD_MESSAGES_COUNT'
export const SET_QUICK_SEARCHES = 'SET_QUICK_SEARCHES'
export const SET_STATISTICS = 'SET_STATISTICS'
